export default {
    browse: 'ファイルを選択',
    dragAndDrop: 'ファイルをドラッグ＆ドロップ もしくは',
    noFileChosen: '選択されていません',
};
